import getElementOffset from './getElementOffset';
export default (element) => {
    const offset = getElementOffset(element);
    return {
        top: offset.y,
        left: offset.x,
        right: offset.x + element.offsetWidth,
        bottom: offset.y + element.offsetHeight,
        size: {
            width: element.offsetWidth,
            height: element.offsetHeight,
        },
    };
};
